// Shared issue-search predicate. Both the dashboard's IssueSearch combobox and
// the Focus refine search filter the project's issue set the same way — by
// title substring or by issue number (the numeric iid, with or without a
// leading "#"). Keep the one matcher here so the two surfaces can't drift.

import type { DashboardIssue } from "@loom/shared/dashboard";

export const MAX_ISSUE_RESULTS = 8;

export const matchIssues = (
  issues: ReadonlyArray<DashboardIssue>,
  raw: string,
): DashboardIssue[] => {
  const q = raw.trim().toLowerCase();
  if (q === "") return [];
  // A query of just digits (optionally prefixed with #) matches by iid; a
  // numeric prefix match is friendlier than exact-equality while typing.
  const numeric = q.replace(/^#/, "");
  const byNumber = /^\d+$/.test(numeric);
  return issues
    .filter((i) => {
      if (i.title.toLowerCase().includes(q)) return true;
      if (byNumber && String(i.iid).startsWith(numeric)) return true;
      return false;
    })
    .slice(0, MAX_ISSUE_RESULTS);
};
